// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"1997":"40165343","3539":"67ef751d"}[chunkId] + ".css";
};